import { Button, Icon, Input, Modal, Spin } from 'antd';
import React from 'react';
import Header from '../../../components/header';
import handleException from './../../../services/handleException';
import history from './../../../services/history';
import { changePassword } from './../../../utils/changePassword';
import { checkInputEmpty, checkValidatePassword } from './helper';
import './styles.css';
import { alertSuccess, alertError } from './../../../services/dialog'
import lang from './../../../languages/en'
import { titleHead } from './../../../services/helper'
import checkPermission from './../../../services/checkPermission'
import { permissions } from './../../../constants'
import handlePermission from './../../app/handlePermission'

class ChangePassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            inputs: {
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: '',
            },
            passwordMerge: true,
            isDisable: false,
            message: {},
            isLoading: false
        }
    }
    
    componentDidMount() {
        titleHead('Change Password')
    }

    unmask = (id) => {
        let x = document.getElementById(id);
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    onOk = () => {
        history.push('/setting/account')
    }

    checkEmpty = (value, name) => {
        this.setState({
            message: checkInputEmpty(value, name),
        })
    }

    onChange = (value, name) => {
        this.checkEmpty(value, name)
        this.setState({
            inputs: {
                ...this.state.inputs,
                [name]: value,
            },
        })
    }

    validate = () => {
        const { newPassword, confirmNewPassword } = this.state.inputs;
        let message = checkValidatePassword(newPassword, confirmNewPassword)
        if (!Object.keys(message).length) return true

        this.setState({
            message
        })
        return false;
    }

    onSubmit = (e) => {
        e.preventDefault()
        if (!this.validate()) return;

        let oldPassword = this.state.inputs.oldPassword
        let newPassword = this.state.inputs.newPassword
        let data = {
            oldPassword,
            newPassword,
        }

        this.setState({
            isLoading: true
        })
        changePassword(data).then(res => {
            if (res.data.code === 10001) {
                alertSuccess(lang.change_password_sucess, null, () => history.push('/setting/account'))
            } else {
                handleException(res)
            }

            this.setState({
                isLoading: false,
            })
        })
    }

    checkButtonSubmit = () => {
        const { oldPassword, newPassword, confirmNewPassword } = this.state.inputs;
        if (!oldPassword || !newPassword || !confirmNewPassword) return true;
        return false;
    }

    render() {
        return (
            <div id="change-password">
                <Header />
                <Spin tip='Loading' spinning={this.state.isLoading}>
                    <div className="content">
                        <div className="change-password-form">
                            <h1>Change Password</h1>
                            <form
                                autoComplete="off"
                                className='form-change-password'
                            >
                                <div className="input-align-left">
                                    <label>Current password</label>
                                    <Input
                                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        id="oldPassword"
                                        type="password"
                                        placeholder="Current password"
                                        onChange={e => this.onChange(e.target.value, 'oldPassword')}
                                        addonAfter={<span onClick={e => { this.unmask("oldPassword") }} style={{ cursor: "pointer" }} ><Icon type="eye" /></span>}
                                        autoComplete="off"
                                        maxLength={32}
                                    />
                                    <span className='message'>{this.state.message.name === 'oldPassword' && this.state.message.value}</span>
                                </div>
                                <div className="input-align-left">
                                    <label>New password</label>
                                    <Input
                                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        id='newPassword'
                                        type="password"
                                        placeholder="New password"
                                        onChange={e => this.onChange(e.target.value, 'newPassword')}
                                        addonAfter={<Icon type="eye" />}
                                        addonAfter={<span onClick={e => this.unmask("newPassword")} style={{ cursor: "pointer" }} ><Icon type="eye" /></span>}
                                        autoComplete="off"
                                        maxLength={32}
                                    />
                                    <span className='message'>{this.state.message.name === 'newPassword' && this.state.message.value}</span>
                                </div>
                                <div className="input-align-left">
                                    <label>Confirm new password</label>
                                    <Input
                                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        type="password"
                                        id='confirmNewPassword'
                                        placeholder="Confirm new password"
                                        onChange={e => this.onChange(e.target.value, 'confirmNewPassword')}
                                        addonAfter={<span onClick={e => this.unmask("confirmNewPassword")} style={{ cursor: "pointer" }} ><Icon type="eye" /></span>}
                                        autoComplete="off"
                                        maxLength={32}
                                    />
                                    <span className='message'>{this.state.message.name === 'confirmNewPassword' && this.state.message.value}</span>
                                    <div className="ant-form-explain password-not-merge message">
                                        {this.state.message.name === 'error' && this.state.message.value}
                                    </div>
                                </div>
                                <div className='button'>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="login-form-button"
                                        disabled={this.checkButtonSubmit()}
                                        onClick={(e) => this.onSubmit(e)}
                                    >Change Password</Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Spin>
            </div>
        )
    }
}

export default ChangePassword


// WEBPACK FOOTER //
// ./src/containers/auth/change-password/index.js